import { render, staticRenderFns } from "./licationSuccess.vue?vue&type=template&id=3fa14080"
import script from "./licationSuccess.vue?vue&type=script&lang=js"
export * from "./licationSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports